import { render } from "./GameTransfer.vue?vue&type=template&id=039177bb&scoped=true"
import script from "./GameTransfer.vue?vue&type=script&lang=js"
export * from "./GameTransfer.vue?vue&type=script&lang=js"

import "./GameTransfer.vue?vue&type=style&index=0&id=039177bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039177bb"]])

export default __exports__